import _pt from "prop-types";
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import CheckRound from '@ori-ui/icons/lib/CheckRound';
import InfoOutlined from '@ori-ui/icons/lib/InfoOutlined';
import RoundExclam from '@ori-ui/icons/lib/RoundExclam';
import RoundQuestion from '@ori-ui/icons/lib/RoundQuestion';
import clsx from 'clsx';
import React, { useMemo } from 'react';
import DialogBase from '../DialogBase';
import { addClassName } from '../utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export let FeedbackType;

(function (FeedbackType) {
  FeedbackType["Positive"] = "Positive";
  FeedbackType["Negative"] = "Negative";
  FeedbackType["Info"] = "Info";
  FeedbackType["Pending"] = "Pending";
})(FeedbackType || (FeedbackType = {}));

const styles = theme => ({
  root: {
    padding: 0,
    gridTemplateAreas: `
        'banner'
        'content'`,
    justifyItems: 'stretch',
    gridTemplateRows: '110px auto',
    gridTemplateColumns: 'auto',
    overflow: 'hidden',
    minWidth: 330,
    [theme.breakpoints.up('sm')]: {
      minWidth: 360,
      gridTemplateRows: '120px auto'
    }
  },
  banner: {
    justifySelf: 'stretch',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 80,
    color: theme.palette.common.black,
    gridArea: 'banner'
  },
  content: {
    display: 'grid',
    gridArea: 'content',
    padding: theme.spacing(0, 3, 6, 3),
    rowGap: `${theme.spacing(3)}px`,
    justifyItems: 'center',
    gridTemplateAreas: `
        'header'
        'content'
        'actions'
      `,
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(0, 6, 6, 6)
    }
  },
  header: {
    gridArea: 'header',
    textAlign: 'center'
  },
  text: {
    gridArea: 'content',
    textAlign: 'center'
  },
  actions: {
    gridArea: 'actions',
    display: 'grid',
    justifySelf: 'stretch',
    rowGap: `${theme.spacing(3)}px`,
    marginTop: theme.spacing(6)
  },
  severityPositive: {
    color: theme.palette.success.main
  },
  severityNegative: {
    color: theme.palette.error.light
  },
  severityInfo: {
    color: theme.palette.info.main
  },
  severityPending: {
    color: theme.palette.warning.main
  },
  fontInherit: {
    fontSize: 'inherit'
  }
});

const componentConfig = {
  name: 'MuiOriFeedbackDialog'
};
const iconsMapping = {
  [FeedbackType.Positive]: /*#__PURE__*/_jsx(CheckRound, {
    fontSize: "inherit",
    color: "inherit",
    "data-testid": "positive-icon"
  }),
  [FeedbackType.Negative]: /*#__PURE__*/_jsx(RoundExclam, {
    fontSize: "inherit",
    color: "inherit",
    "data-testid": "negative-icon"
  }),
  [FeedbackType.Info]: /*#__PURE__*/_jsx(InfoOutlined, {
    fontSize: "inherit",
    color: "inherit",
    "data-testid": "info-icon"
  }),
  [FeedbackType.Pending]: /*#__PURE__*/_jsx(RoundQuestion, {
    fontSize: "inherit",
    color: "inherit",
    "data-testid": "pending-icon"
  })
};
export const FeedbackDialog = props => {
  const {
    header,
    children,
    actions,
    type = 'Info',
    icon,
    open,
    classes,
    ...rest
  } = props;
  const internalIcon = useMemo(() => icon != null ? icon : iconsMapping[type], [icon, type]);
  const internalChildren = addClassName(children, classes.fontInherit);
  return /*#__PURE__*/_jsxs(DialogBase, { ...rest,
    open: open,
    classes: {
      dialogGrid: classes.root
    },
    children: [/*#__PURE__*/_jsx("div", {
      className: clsx(classes.banner, classes[`severity${type}`]),
      children: internalIcon
    }), /*#__PURE__*/_jsxs("div", {
      className: classes.content,
      children: [header && /*#__PURE__*/_jsx(Typography, {
        variant: "h5",
        classes: {
          root: classes.header
        },
        children: header
      }), internalChildren && /*#__PURE__*/_jsx(Typography, {
        component: "div",
        classes: {
          root: classes.text
        },
        children: internalChildren
      }), actions && /*#__PURE__*/_jsx("div", {
        className: classes.actions,
        children: actions
      })]
    })]
  });
};
FeedbackDialog.propTypes = {
  header: _pt.string,
  type: _pt.any
};
export default withStyles(styles, componentConfig)(FeedbackDialog);